import { vanishElement } from "../../utils/vanish_element";

let listeners = [];

function addListener(listener) {
  listeners = [...listeners, listener];
}

function removeListener(listener) {
  listeners = listeners.filter(registeredListener => registeredListener !== listener);
}

function createToggleTabHandler(tabTriggersList, contentsContainerElement) {
  return function toggleTabHandler(event) {
    event?.preventDefault();

    if (event?.target.disabled) return;

    const contentIdToShow = this.dataset?.contentContainerId; // this uses data-content-container-id attr

    tabTriggersList.forEach((tabTriggerElement) => {
      tabTriggerElement.classList.toggle("active-tab", this === tabTriggerElement);
    });

    const childrenList = Array.from(contentsContainerElement.children);

    childrenList.forEach((child) => {
      if (child?.classList.contains("mpm-tab-contents")) {
        const isActiveTabContentsContainer = child.id === contentIdToShow;
        vanishElement(child, !isActiveTabContentsContainer);
      }
    });

    listeners.forEach((listener) => {
      listener(this.dataset.paymentMethod, this);
    });
  };
}

export function setupMPMTabs(tabsContentsContainerElement) {
  const mpmButtonsMap = new Map(
    Array.from(
      document.getElementsByClassName("tab-trigger")
    ).map((element, _idx, tabTriggerList) => {
        const paymentMethod = element?.dataset?.paymentMethod;
        if (!paymentMethod) {
          console.error("Tab trigger element is missing data-payment-method attribute:", element);
          return null;
        }
        const targetContentId = element?.dataset?.contentContainerId;
        const contentContainerElement = document.getElementById(targetContentId);
        const clickHandler = createToggleTabHandler(tabTriggerList, tabsContentsContainerElement, targetContentId);
        element.addEventListener("click", clickHandler);
        return [paymentMethod, {
          clickHandler,
          element,
          contentContainerElement
        }];
      }
    )
  );

  const tabButtonsList = Array.from(mpmButtonsMap.values()).map(({ element }) => element);

  function setButtonsDisabled(state) {
    tabButtonsList.forEach((element) => {
      if (state) {
        element.classList.toggle("disabled", true);
        element.setAttribute("disabled", true);
      } else {
        element.classList.toggle("disabled", false);
        element.removeAttribute("disabled");
      }
    });
  }

  return {
    map: mpmButtonsMap,
    addListener,
    removeListener,
    setButtonsDisabled
  };
};
